import React from 'react';
import styles from './Content.module.scss';

const Content = ({ shutdown }) => {
  return (
    <ul className={styles.root}>
      {shutdown.notifyTo.map((item) => (
        <li key={item.id}>{item.name}</li>
      ))}
    </ul>
  );
};

export default Content;
